import styled from '@emotion/styled';
import { withConfig } from 'src/utils/withConfig';
import { setMainLogoWrapper } from 'src/components/Header/Logotype.style';
import { BestOddsCompliancePopupLogo } from 'src/assets/logos/compliancePopup/BestOddsCompliancePopupLogo';
import { BestOddsLogo } from 'src/assets/logos/BestOddsLogo';
import { BestOddsBrandIcon } from 'src/assets/brandIcons/BestOddsBrandIcon';
import { compliancePopupLogoCss } from 'src/domains/common/universes/compliancePopupLogoCss';

export const BestOddsMainLogoWrapper = withConfig(theme => styled('div', { label: 'BestOddsMainLogoWrapper' })`
    ${setMainLogoWrapper(theme)};
`);

export const BestOddsMainLogo = styled(BestOddsLogo, { label: 'BestOddsMainLogo' })`
    width: 124px;
    height: 32px;
    margin: 0 auto;
`;

export const BestOddsBrandIconWrapper = styled(BestOddsBrandIcon, { label: 'BestOddsBrandIconWrapper' })`
    cursor: pointer;
    flex: 0 0 32px;
    margin: 0 auto;
    width: 32px;
`;

export const CompliancePopupLogo = styled(BestOddsCompliancePopupLogo, { label: 'CompliancePopupLogo' })`
    ${compliancePopupLogoCss}
`;
